import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ClaimDetailView from '../components/claims/ClaimDetailView';

// /admin/claims/:id — the shared detail view with the office's actions.
export default function AdminClaimDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  useEffect(() => { if (!localStorage.getItem('token')) navigate('/'); }, [navigate]);
  return <ClaimDetailView claimId={id} role="admin" backTo="/admin/claims" />;
}
